import { formatNumber as _formatNumber, formatPercent as _formatPercent, formatPrice as _formatPrice } from '../utils/number'
import { useLocale } from './locale'

export function useLocaleNumber() {
  const { locale } = useLocale()

  function formatNumber(number: number | bigint) {
    return _formatNumber(Number(number), {
      locale: locale.value.code,
    })
  }

  function formatPrice(price: number) {
    return _formatPrice(price, {
      locale: locale.value.code,
    })
  }

  function formatPercent(percent: number) {
    return _formatPercent(percent, {
      locale: locale.value.code,
    })
  }

  return {
    formatNumber,
    formatPrice,
    formatPercent,
  }
}
